import { combineReducers } from 'redux';
import { login, login_isloading, login_error } from './reducer_login';
import { queryInfo, queryInfo_isloading, queryInfo_error, bgSetting, menuSetting }  from './reducer_settings'; 
import { leaderInfo, leaderInfo_isloading, leaderInfo_error }  from './reducer_leaderinfo';
import { menuStatus }  from './reducer_topusers';
import { catlist, catlist_isloading, catlist_error } from './reducer_catlist';
import { taglist, taglist_isloading, taglist_error } from './reducer_taglist';
import { kolranking, kolranking_isloading, kolranking_error } from './reducer_kolranking';
import { kolprofile, kolprofile_isloading, kolprofile_error } from './reducer_kolprofile';
import { postlist, postlist_isloading, postlist_error } from './reducer_postlist';
import { account, account_isloading, account_error } from './reducer_account';
import { myfavorite, myfavorite_isloading, myfavorite_error } from './reducer_myfavorite';

const rootReducer = combineReducers({
	login,
	login_isloading,
	login_error,
	queryInfo,
	queryInfo_isloading,
	queryInfo_error,
	bgSetting,
	menuSetting,
	leaderInfo,
	leaderInfo_isloading,
	leaderInfo_error,
	menuStatus,
	catlist,
	catlist_isloading,
	catlist_error,
	taglist,
	taglist_isloading,
	taglist_error,
	kolranking,
	kolranking_isloading,
	kolranking_error,
	kolprofile,
	kolprofile_isloading,
	kolprofile_error,
	postlist,
	postlist_isloading,
	postlist_error,
	account,
	account_isloading,
	account_error,
	myfavorite,
	myfavorite_isloading,
	myfavorite_error,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js